import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  DispatchGridView,
  DispatchGridViews,
  GRID_VIEW_URL,
  GridType,
  GridView,
  GridViewsState,
} from '@data-access/grid-views';
import { WcgMenuOption } from '@wcg/frontend-framework';
import { map, Observable } from 'rxjs';
import environment from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GridViewService {
  private readonly _http = inject(HttpClient);

  saveGridView(gridView: GridView): Observable<GridView> {
    return this._http.post<GridView>(GRID_VIEW_URL, {
      data: btoa(JSON.stringify(gridView)),
    });
  }

  bulkGridViewUpdate(payload: DispatchGridViews): Observable<GridView[]> {
    const url = `${GRID_VIEW_URL}bulk-update/`;
    return this._http.put<GridView[]>(url, {
      data: btoa(JSON.stringify({ ...payload })),
    });
  }

  updateGridView(payload: DispatchGridView): Observable<GridView> {
    const url = `${GRID_VIEW_URL}${payload.gridView.id}/`;
    return this._http.put<GridView>(url, {
      data: btoa(JSON.stringify(payload.gridView)),
    });
  }

  getTotalGridViews(gridType: GridType): Observable<GridViewsState> {
    const url = `${GRID_VIEW_URL}?grid_type=${gridType}`;
    return this._http.get<GridViewsState>(url);
  }

  getFilterOptions(endpoint: string): Observable<WcgMenuOption[]> {
    return this._http
      .get<
        { data?: unknown[] } | unknown[]
      >(`${environment.irisApi}${endpoint}`)
      .pipe(
        map((response) => {
          const list = Array.isArray(response)
            ? response
            : ((response as { data?: unknown[] })?.data ?? []);

          return list.map((item) => {
            const typedItem = item as {
              id: string;
              value?: string;
              name?: string;
              title?: string;
              label?: string;
            };
            return {
              label: typedItem.label ?? typedItem.name ?? typedItem.title ?? '',
              value:
                typedItem.value ??
                typedItem.name ??
                typedItem.id ??
                typedItem.label ??
                typedItem.title ??
                '',
            };
          });
        }),
      );
  }
}
